import { Link } from 'react-router-dom';
import type { TopicWithMeta } from '@/lib/community';
import { formatCount, formatRelativeTime } from '@/lib/format';
import CategoryBadge from '@/components/feature/CategoryBadge';

interface RelatedTopicsProps {
  topics: TopicWithMeta[];
}

export default function RelatedTopics({ topics }: RelatedTopicsProps) {
  if (topics.length === 0) {
    return (
      <section className="bg-background-50 border border-background-200 rounded-lg p-5">
        <h2 className="text-base font-extrabold text-foreground-900 mb-3">相关话题推荐</h2>
        <p className="text-sm text-foreground-400">该分类下暂无其他推荐内容。</p>
      </section>
    );
  }

  return (
    <section className="bg-background-50 border border-background-200 rounded-lg p-5">
      <div className="flex items-center gap-2 mb-4">
        <i className="ri-links-line text-accent-600" />
        <h2 className="text-base font-extrabold text-foreground-900">相关话题推荐</h2>
      </div>
      <div className="flex flex-col gap-3">
        {topics.map((topic) => (
          <Link
            key={topic.id}
            to={`/topic/${topic.id}`}
            className="group flex gap-3 cursor-pointer"
          >
            <span className="w-16 h-16 rounded-md overflow-hidden bg-background-200 shrink-0">
              <img src={topic.cover} alt={topic.title} title={`${topic.title} - 蜜糖社区`} className="w-full h-full object-top transition-transform duration-500 group-hover:scale-105" />
            </span>
            <span className="min-w-0 flex-1">
              <span className="block text-sm font-bold text-foreground-900 leading-snug line-clamp-2 group-hover:text-primary-700 transition-colors">
                {topic.title}
              </span>
              <span className="mt-1.5 flex items-center gap-2 flex-wrap">
                <CategoryBadge name={topic.category.name} color={topic.category.color} />
                <span className="text-[11px] text-foreground-400 inline-flex items-center gap-1">
                  <i className="ri-chat-3-line" />
                  {formatCount(topic.replyCount)}
                </span>
                <span className="text-[11px] text-foreground-400">{formatRelativeTime(topic.createdAt)}</span>
              </span>
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}